/** @format */

import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    fetch(
      `https://b610-lerning-platform-server-side-shariyer.vercel.app/courses`
    )
      .then((res) => res.json())
      .then((data) => {
        setCategories(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return (
    <div className="my-2">
      <h4 className="text-sm-start text-center fs-3 fw-bold">
        Programme Categories
      </h4>
      {categories.map((category) => (
        <NavLink
          className="d-block m-4 fs-3"
          to={`singleCourse/${category.id}`}
          key={category.id}
        >
          {category.name}
        </NavLink>
      ))}
    </div>
  );
};

export default Categories;
